import {
    type SubEventUploadTokenRequestType,
    type UploadTokenResponseType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForSubEventCover = async (params: SubEventUploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForSubEventCover", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForSubEventCover;
